'use client';

import { ProductDifferentialsItemsData } from '@/types/product-pages';
import Image from 'next/image';
import { useState } from 'react';

interface ProductDifferentialsMainProps {
  data: ProductDifferentialsItemsData[];
}

export default function ProductDifferentialsMain({
  data,
}: ProductDifferentialsMainProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedContent = data[selectedIndex];

  return (
    <div className="inline-flex flex-col lg:flex-row gap-6">
      {/* Coluna 1: Botões quadrados */}
      <div className="flex flex-row lg:flex-col w-full lg:w-auto gap-2">
        {data.map((item, index) => {
          const isSelected = index === selectedIndex;
          return (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className={`flex-1 lg:px-2 aspect-[1/1] border-2 gap-2 item-tab flex flex-col justify-center items-center rounded-md transition-colors ${
                isSelected
                  ? 'bg-bluecaixa border-transparent'
                  : 'border-stone-300 hover:border-stone-400'
              }`}
            >
              <Image src={item.iconSrc} alt="" height={24} width={24} />
              <span
                className={`lg:font-semibold text-[10px] lg:text-sm ${isSelected ? 'text-white' : 'text-[#525252]'}`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Coluna 2: Imagem dinâmica */}
      <div className="relative w-full lg:w-auto lg:h-[29.5rem] aspect-[536/410]">
        <Image
          src={selectedContent.imgSrc}
          alt={`Imagem para ${selectedContent.label}`}
          fill
          className="object-cover rounded-xl rounded-br-[100px]"
        />
      </div>

      {/* Coluna 3: Textos dinâmicos */}
      <div className="flex-1 lg:pl-8 gap-2 flex flex-col">
        <h1 className="text-2xl text-bluecaixa font-extrabold">
          {selectedContent.title}
        </h1>

        {selectedContent.texts.map((text, idx) => (
          <div
            key={idx}
            className="flex flex-row items-center gap-4 py-6 border-b border-stone-300"
          >
            <Image
              src="/icons/arrow-right-circle-orange.png"
              alt="Arrow Right"
              height={24}
              width={24}
            />
            <p className="text-[#525252] w-full text-base font-thin leading-relaxed">
              {text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
